// extracted by mini-css-extract-plugin
module.exports = {"linkArrow":"dateFinder_linkArrow__1H5jU","arrow":"dateFinder_arrow__1sDrc"};